module.exports = __webpack_public_path__ + "assets/691932dc0a15bdb6e926c6c4ce7b2998.mp3";


/*****************
 ** WEBPACK FOOTER
 ** ./public-src/sounds/freespin/FreeGameCountUp.mp3
 ** module id = 345
 ** module chunks = 0
 **/